import { FormField } from '../../../types/form-builder.types';
import { useLanguage } from '@shondalai/ui-commons';

interface DateFieldProps {
  field: FormField;
  value: any;
  onChange: (value: any) => void;
  error?: string;
}

export function DateField({ field, value, onChange }: DateFieldProps) {
  const config = field.config;
  const { t } = useLanguage();

  // For date-range, handle as object with start and end
  if (field.type === 'date-range') {
    const rangeValue = value || { start: '', end: '' };
    
    return (
      <div className="grid grid-cols-2 gap-3">
        <div className="easyforms-field-group">
          <label className="easyforms-field-label">{t('COM_EASYFORMS_START_DATE', 'Start Date')}</label>
          <input
            type="date"
            value={rangeValue.start || ''}
            onChange={(e) => onChange({ ...rangeValue, start: e.target.value })}
            className="easyforms-field-input"
          />
        </div>
        <div className="easyforms-field-group">
          <label className="easyforms-field-label">{t('COM_EASYFORMS_END_DATE', 'End Date')}</label>
          <input
            type="date"
            value={rangeValue.end || ''}
            onChange={(e) => onChange({ ...rangeValue, end: e.target.value })}
            className="easyforms-field-input"
          />
        </div>
      </div>
    );
  }

  return (
    <input
      id={field.id}
      type={field.type}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      required={config.required}
      min={config.min}
      max={config.max}
      className="easyforms-field-input"
    />
  );
}
